import { Component } from "react";
import { Alert, Button, Container, FormLabel, Table } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import "../../../assets/css/geral.scss";
import * as highspotAction from "../../../actions/partnerPortal/highspot/HighspotAction";

import { RouteComponentProps } from "react-router";
import Column from "../../../models/common/Column";
import HighspotFilesState from "./HighspotFilesState";
import HighspotFileIntegrationDTO from "../../../models/HighspotFileIntegrationDTO";
import RequestFileSearchDTO from "../../../models/RequestFileSearchDTO";

const RESOURCE_TYPE = [
  "Battlecards",
  "Blog post",
  "Customer story",
  "Demo",
  "eBook",
  "Event",
  "Fact sheet",
  "Infographic",
  "Partner story",
  "Product tours",
  "Report",
  "Sales tools",
  "Use case",
  "Video",
  "Webinar",
];

const OTHER = ["Highspot", "Partner Tech Talk", "Business Insights"];

const TECHNOLOGY = [
  "AWS",
  "Azure",
  "Google",
  "Kubernetes",
  "OpenShift",
  "OpenTelemetry",
  "ServiceNow",
  "VMware Tanzu",
];

const TOPIC = [
  "AIOps / AI & Automation",
  "Application Performance Monitoring",
  "Application Security",
  "Certifications",
  "Davis",
  "DevOps",
  "Digital Experience",
  "DPS",
  "Grail",
  "Infrastructure Monitoring",
  "Logs Management",
  "Observability",
  "Other",
  "Partner Program",
  "Price List",
  "Serverless Monitoring",
  "Training & Enablement",
  "US Government",
];

class HighspotFIles extends Component<RouteComponentProps, HighspotFilesState> {
  state: Readonly<HighspotFilesState> = {
    files: new Array<HighspotFileIntegrationDTO>(),
    filesToSave: new Array<HighspotFileIntegrationDTO>(),
    email: "manual",
    account: "manual",
    status: "TO_APPROVE",
    columns: [],
    highspotUrl: process.env.REACT_APP_HIGHSPOT_LINK || "",
    loading: true,
    search: new RequestFileSearchDTO(
      0,
      10,
      ["Partner"],
      [false],
      false,
      false,
      false,
      new Date(Date.UTC(2023, 3, 1))
    ),
    totalElements: 0,
    totalPages: [0],
  };

  canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        this.props.history.push("/not-found");
      }
    } catch (err) {}
  }

  getPersonAccessingThePage() {
    // localStorage from zinfi to input field
    let emailValue = "manual";
    window.addEventListener(
      "message",
      function (event) {
        var origin = event.origin; // For Chrome, the origin property is in the event.originalEvent object.
        if (origin !== "https://partners.dynatrace.com") {
          return;
        }

        if (typeof event.data == "object" && event.data.call == "sendValue") {
          // Do something with event.data.value;
          var userInfo = event.data.value;
          if (origin == "https://partners.dynatrace.com") {
            console.log(userInfo);
            emailValue = userInfo.email;
          }
        }
      },
      false
    );
    this.setState({ email: emailValue });
  }

  componentDidMount() {
    this.canYouHaveAccess();
    this.getAllFiles();
    this.getColumns();
    this.getPersonAccessingThePage();
  }

  showFiles() {
    const { highspotUrl, filesToSave, files } = this.state;
    return files.map((f) => {
      const fileExist =
        filesToSave.find((saved) => saved.id === f.id) !== undefined;
      return (
        <tr key={f.id}>
          <td>
            <input
              type="checkbox"
              checked={filesToSave.some((s) => s.id === f.id)}
              onChange={(e) => this.onSelect(e, f)}
            />
          </td>
          <td key={f.id}>
            <b>Title: </b>
            <br />
            <a href={highspotUrl + f.file?.ziftId} target="_blank">
              {f.file?.title}
            </a>
            <br />
            <br />
            <b>Description: </b>
            <br />
            {f.file?.description}
            <br />
            <br />
            <b>Label: </b>
            {f.file?.label}
            <br />
            <b>Language: </b>
            {f.file?.language ? f.file?.language[0] : ""}
            <br />
            <b>Processed: </b>
            {f.isProcess ? "YES" : "NO"}
            <br />
            <b>Last Updated: </b>
            {f.file?.lastUpdated}
            <br />
            <b>Last imported: </b>
            {f.file?.importedAt}
            <br />
            <br />
            <b>Title for the portal</b>
            <br />
            (highspot title will be used if this field not populated)
            <input
              value={f.file?.titleZift || ""}
              onChange={(e) => this.onTitleSet(e, f.id || 0)}
              disabled={!fileExist}
              size={40}
            />
            <br />
            <b>Description for the portal</b>
            <br />
            (highspot description will be used if this field not populated)
            <textarea
              value={f.file?.descriptionZift || ""}
              onChange={(e) => this.onDescriptionSet(e, f.id || 0)}
              disabled={!fileExist}
              rows={6}
              cols={40}
            />
            <br />
            {f.highspotId !== f.highspotIdLog ? (
              <div>
                <b>DELETED:</b> AUTO - file no longer on Highspot
              </div>
            ) : (
              ""
            )}
          </td>
          <td>
            <b>RESOURCE TYPE</b>
            <br />
            <br />
            {RESOURCE_TYPE.map((type) => {
              return (
                <label>
                  <input
                    className="mr-1 ml-2"
                    type="checkbox"
                    checked={f.file?.resourceType?.includes(type)}
                    onChange={() => this.onResourceSelect(type, f.id || 0)}
                    disabled={!fileExist}
                  />
                  {type}
                </label>
              );
            })}
            <br />
            <br />
            <b>TECHNOLOGY</b>
            <br />
            <br />
            {TECHNOLOGY.map((type) => {
              return (
                <label>
                  <input
                    className="mr-1 ml-2"
                    type="checkbox"
                    checked={f.file?.technology?.includes(type)}
                    onChange={() => this.onTechnologySelect(type, f.id || 0)}
                    disabled={!fileExist}
                  />
                  {type}
                </label>
              );
            })}
            <br />
            <br />
            <b>TOPIC</b>
            <br />
            <br />
            {TOPIC.map((type) => {
              return (
                <label>
                  <input
                    className="mr-1 ml-2"
                    type="checkbox"
                    checked={f.file?.topic?.includes(type)}
                    onChange={() => this.onTopicSelect(type, f.id || 0)}
                    disabled={!fileExist}
                  />
                  {type}
                </label>
              );
            })}
            <br />
            <br />
            <b>OTHER</b>
            <br />
            <br />
            {OTHER.map((type) => {
              return (
                <label>
                  <input
                    className="mr-1 ml-2"
                    type="checkbox"
                    checked={f.file?.other?.includes(type)}
                    onChange={() => this.onOtherSelect(type, f.id || 0)}
                    disabled={!fileExist}
                  />
                  {type}
                </label>
              );
            })}
          </td>
        </tr>
      );
    });
  }

  onSelect = (e, file: HighspotFileIntegrationDTO) => {
    const { filesToSave } = this.state;
    const isChecked = e.target.checked;
    if (isChecked) {
      filesToSave.push(file);
      this.setState({ filesToSave: filesToSave });
      return;
    }

    this.setState({ filesToSave: filesToSave.filter((f) => f.id !== file.id) });
  };

  onDescriptionSet = (e, fileId: number) => {
    const { files } = this.state;
    const description = e.target.value;

    const fileMaster = files.find((f) => f.id === fileId);
    if (fileMaster && fileMaster.file) {
      fileMaster.file.descriptionZift = description;
    }

    this.setState({ files: files });
  };

  onTitleSet = (e, fileId: number) => {
    const { files } = this.state;
    const title = e.target.value;

    const fileMaster = files.find((f) => f.id === fileId);
    if (fileMaster && fileMaster.file) {
      fileMaster.file.titleZift = title;
    }

    this.setState({ files: files });
  };

  onResourceSelect = (tagName: string, fileId: number) => {
    const { files } = this.state;
    var resultFiles = files.map((f) => {
      if (f.id === fileId) {
        if (f.file?.resourceType?.includes(tagName)) {
          f.file.resourceType = f.file.resourceType.filter(
            (tag) => tag !== tagName
          );
        } else {
          f.file?.resourceType?.push(tagName);
        }
      }
      return f;
    });

    this.setState({ files: resultFiles });
  };

  onTechnologySelect = (tagName: string, fileId: number) => {
    const { files } = this.state;
    var resultFiles = files.map((f) => {
      if (f.id === fileId) {
        if (f.file?.technology?.includes(tagName)) {
          f.file.technology = f.file.technology.filter(
            (tag) => tag !== tagName
          );
        } else {
          f.file?.technology?.push(tagName);
        }
      }
      return f;
    });

    this.setState({ files: resultFiles });
  };

  onTopicSelect = (tagName: string, fileId: number) => {
    const { files } = this.state;
    var resultFiles = files.map((f) => {
      if (f.id === fileId) {
        if (f.file?.topic?.includes(tagName)) {
          f.file.topic = f.file.topic.filter((tag) => tag !== tagName);
        } else {
          f.file?.topic?.push(tagName);
        }
      }
      return f;
    });

    this.setState({ files: resultFiles });
  };

  onOtherSelect = (tagName: string, fileId: number) => {
    const { files } = this.state;
    var resultFiles = files.map((f) => {
      if (f.id === fileId) {
        if (f.file?.other?.includes(tagName)) {
          f.file.other = f.file.other.filter((tag) => tag !== tagName);
        } else {
          f.file?.other?.push(tagName);
        }
      }
      return f;
    });

    this.setState({ files: resultFiles });
  };

  onApprove() {
    var { filesToSave, email } = this.state;
    filesToSave = filesToSave.map((f) => ({
      ...f,
      isApproved: true,
      isDeleted: false,
      isProcess: false,
      wasUpdated: false,
      lastUpdatedBy: email,
    }));
    this.updateHighspotFiles(filesToSave);
  }

  onReject() {
    var { filesToSave, email } = this.state;
    filesToSave = filesToSave.map((f) => ({
      ...f,
      isProcess: true,
      lastUpdatedBy: email,
    }));
    this.updateHighspotFiles(filesToSave);
  }

  onRemove() {
    var { filesToSave, email } = this.state;
    filesToSave = filesToSave.map((f) => {
      if (f.isProcess) {
        f.isProcess = false;
        f.isApproved = false;
        f.isDeleted = true;
      } else {
        f.isApproved = false;
        f.isProcess = true;
      }
      f.lastUpdatedBy = email;
      f.wasUpdated = false;
      return f;
    });
    this.updateHighspotFiles(filesToSave);
  }

  onUpdate() {
    var { filesToSave, email } = this.state;
    filesToSave = filesToSave.map((f) => ({
      ...f,
      isProcess: false,
      lastUpdatedBy: email,
    }));
    this.updateHighspotFiles(filesToSave);
  }

  onPageChange(pageNumber: number) {
    const { search } = this.state;
    search.page = pageNumber - 1;
    this.setState({ search: search });
    this.getAllFiles();
  }

  getStatus() {
    const { status } = this.state;
    if (status == "TO_APPROVE") {
      return "Files to approve. Not yet processed to partner portal.";
    }
    if (status == "APPROVED") {
      return "Files approved and already on partner portal or on a queue to be added on the portal. Check process status on info field.";
    }
    if (status == "REJECTED") {
      return "Files rejected. Never existed on partner portal.";
    }
    if (status === "DELETED") {
      return "Files were approved and then rejected. No longer at the partner portal, or on a queue to be deleted from the portal. Check process status on info field.";
    }
    if (status === "FILES_UPDATED") {
      return "Files that are already approved. But a new file was imported. To Push the new file, you need to approve again.";
    }
  }

  onStatusChanged(
    isApproved: boolean,
    isDeleted: boolean,
    isProcess: Array<Boolean>,
    wasUpdated: boolean
  ) {
    const { search } = this.state;
    search.isApproved = isApproved;
    search.isDeleted = isDeleted;
    search.isProcessed = isProcess;
    search.wasUpdated = wasUpdated;
    this.setState({ search: search });
  }

  onSearch() {
    const { search } = this.state;
    search.page = 0;
    this.setState({ search: search });
    this.getAllFiles();
  }

  onLabelChanged(label: String) {
    const { search } = this.state;
    const { labels } = search;
    if (labels?.includes(label)) {
      if (labels.length > 0) {
        labels.splice(labels.indexOf(label), 1);
      }
    } else {
      labels?.push(label);
    }
    this.setState({ search: search });
  }

  onSearchWordChange = (e) => {
    const { search } = this.state;
    search.searchWord = e.target.value;
    this.setState({ search: search });
  };

  onSizeChange = (e) => {
    const { search } = this.state;
    search.size = e.target.value;
    this.setState({ search: search });
  };

  onDateChange = (e) => {
    const { search } = this.state;
    search.lastUpdated = new Date(e.target.value);
    this.setState({ search: search });
    console.log(search);
  };

  render() {
    const { status, filesToSave, loading, totalElements, totalPages, search } =
      this.state;
    const searchStatus = this.getStatusValue(
      search.isApproved!,
      search.isDeleted!,
      search.isProcessed!,
      search.wasUpdated!
    );

    return (
      <>
        <Container className="mt-5 ">
          <Alert key="danger" variant="danger">
            Contact gary.llil if you got problems with the form.
          </Alert>
          <br></br>
          <FormLabel className="font-weight-bold ml-3">{"Status"}</FormLabel>
          <br></br>
          <Button
            variant="info"
            className={
              searchStatus === "TO_APPROVE" ? "mb-3 ml-3 active" : "mb-3 ml-3"
            }
            onClick={() => this.onStatusChanged(false, false, [false], false)}
          >
            TO APPROVE
          </Button>
          <Button
            variant="info"
            className={
              searchStatus === "APPROVED" ? "mb-3 ml-3 active" : "mb-3 ml-3"
            }
            onClick={() =>
              this.onStatusChanged(true, false, [true, false], false)
            }
          >
            APPROVED
          </Button>
          <Button
            variant="info"
            className={
              searchStatus === "REJECTED" ? "mb-3 ml-3 active" : "mb-3 ml-3"
            }
            onClick={() => this.onStatusChanged(false, false, [true], false)}
          >
            REJECTED
          </Button>
          <Button
            variant="info"
            className={
              searchStatus === "DELETED" ? "mb-3 ml-3 active" : "mb-3 ml-3"
            }
            onClick={() =>
              this.onStatusChanged(false, true, [true, false], false)
            }
          >
            DELETED
          </Button>
          <Button
            variant="info"
            className={
              searchStatus === "FILES_UPDATED"
                ? "mb-3 ml-3 active"
                : "mb-3 ml-3"
            }
            onClick={() =>
              this.onStatusChanged(true, false, [true, false], true)
            }
          >
            FILES UPDATED
          </Button>
          <span className="ml-3">Choose one status</span>
          <br />
          <br />
          <FormLabel className="font-weight-bold ml-3">{"Labels"}</FormLabel>
          <br></br>
          <Button
            variant="info"
            className={
              search.labels?.includes("Partner")
                ? "mb-3 ml-3 active"
                : "mb-3 ml-3"
            }
            onClick={() => this.onLabelChanged("Partner")}
          >
            Partner
          </Button>
          <Button
            variant="info"
            className={
              search.labels?.includes("Internal")
                ? "mb-3 ml-3 active"
                : "mb-3 ml-3"
            }
            onClick={() => this.onLabelChanged("Internal")}
          >
            Internal
          </Button>
          <Button
            variant="info"
            className={
              search.labels?.includes("External")
                ? "mb-3 ml-3 active"
                : "mb-3 ml-3"
            }
            onClick={() => this.onLabelChanged("External")}
          >
            External
          </Button>
          <span className="ml-3">
            You can choose more than one label. But you might receive a lot of
            records if you choose the 3 together.
          </span>
          <br />
          <br />
          <FormLabel className="font-weight-bold ml-3">
            {"Only show files updated after"}
          </FormLabel>
          <br />
          <input
            className="ml-3"
            type="date"
            value={
              search.lastUpdated
                ? search.lastUpdated.toISOString().substr(0, 10)
                : ""
            }
            onChange={this.onDateChange}
          />
          <br />
          <br />
          <FormLabel className="font-weight-bold ml-3">
            {"Records per page"}
          </FormLabel>
          <br></br>
          <select
            className={"ml-3 mr-5 col5 heightInput36"}
            value={search.size}
            onChange={this.onSizeChange}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
          <input
            className={"ml-5 w-25 heightInput36"}
            type="text"
            placeholder={"search a word"}
            onChange={this.onSearchWordChange}
          />
          <Button
            variant="primary"
            className="mb-3 ml-3"
            onClick={() => this.onSearch()}
          >
            Search
          </Button>
        </Container>
        <Container className="mt-5 mb-4 ">
          <FormLabel className="font-weight-bold ml-3">
            {"Current presented records"}
          </FormLabel>
          <br />
          <span className="ml-3">
            <b>{status + ": "}</b>
            {this.getStatus()}
          </span>
          <br />
          <span className="ml-3">
            <b>How many files to check: </b>
            {totalElements}
          </span>
          <br />
          <br />
          {status === "TO_APPROVE" && (
            <Button
              variant="primary"
              className="mb-3 ml-3"
              onClick={() => this.onApprove()}
            >
              APPROVE
            </Button>
          )}
          {status === "TO_APPROVE" && (
            <Button
              variant="danger"
              className="mb-3 ml-3"
              onClick={() => this.onReject()}
            >
              REJECT
            </Button>
          )}
          {status === "APPROVED" && (
            <Button
              variant="primary"
              className="mb-3 ml-3"
              onClick={() => this.onRemove()}
            >
              DELETE
            </Button>
          )}
          {status === "APPROVED" && (
            <Button
              variant="danger"
              className="mb-3 ml-3"
              onClick={() => this.onUpdate()}
            >
              UPDATE
            </Button>
          )}
          {status === "REJECTED" && (
            <Button
              variant="primary"
              className="mb-3 ml-3"
              onClick={() => this.onApprove()}
            >
              APPROVE
            </Button>
          )}
          {status === "DELETED" && (
            <Button
              variant="danger"
              className="mb-3 ml-3"
              onClick={() => this.onApprove()}
            >
              APPROVE
            </Button>
          )}
          {status === "FILES_UPDATED" && (
            <Button
              variant="primary"
              className="mb-3 ml-3"
              onClick={() => this.onApprove()}
            >
              APPROVE AGAIN
            </Button>
          )}
          {status === "FILES_UPDATED" && (
            <Button
              variant="danger"
              className="mb-3 ml-3"
              onClick={() => this.onRemove()}
            >
              DELETE
            </Button>
          )}
          <span className="ml-3">
            <b>How many files to saved: </b>
            {filesToSave.length}
          </span>
          <br />
          {loading && (
            <span className="ml-3 text-danger">
              <b>LOADING...</b>
            </span>
          )}
          <br />
          {status === "FILES_UPDATED" && (
            <span className="ml-3 text-primary">
              <b>You can't filter files updated. You see them all.</b>
            </span>
          )}
        </Container>
        <Container className="mb-5">
          <Table className="mt-3" striped bordered hover responsive="md">
            <thead>
              <tr>{this.showColumns()}</tr>
            </thead>
            <tbody>{this.showFiles()}</tbody>
          </Table>
          <ul className="pagination">
            {totalPages.map((pageNumber) => (
              <li
                key={pageNumber}
                className={
                  pageNumber === (search.page || 0) + 1 ? "active" : ""
                }
                onClick={() => this.onPageChange(pageNumber)}
              >
                {pageNumber}
              </li>
            ))}
          </ul>
        </Container>
      </>
    );
  }

  async updateHighspotFiles(filesToSave: Array<HighspotFileIntegrationDTO>) {
    const { status } = this.state;
    this.setState({ loading: true });
    highspotAction
      .updateHighspotFilesOnDB(filesToSave)
      .then((response) => {
        this.getAllFiles();
      })
      .catch((err) =>
        alert("updating DB failed! Contact gary.llil@dynatrace.com")
      );
  }

  async getAllFiles() {
    const { search, totalElements } = this.state;
    this.setState({ loading: true });
    highspotAction
      .getAllHighspotFIlesByCriteria(search)
      .then((response) => {
        const files: Array<HighspotFileIntegrationDTO> =
          response.data.content[0];
        let howManyFiles = totalElements;
        if (search.page === 0 && search.size! > files.length) {
          howManyFiles = files.length;
        } else if (search.page === 0) {
          howManyFiles = response.data.totalElements;
        }
        this.setState({
          files: files,
          filesToSave: new Array<HighspotFileIntegrationDTO>(),
          status: this.getStatusValue(
            search.isApproved || false,
            search.isDeleted || false,
            search.isProcessed || [false],
            search.wasUpdated!
          ),
          totalElements: howManyFiles,
          totalPages: Array.from(
            { length: response.data.totalPages },
            (_, i) => i + 1
          ),
        });
      })
      .then((r) => this.setState({ loading: false }))
      .catch((err) => {
        alert(
          "loading events failed. Make sure you have the vpn on (Linz or Maidenhead location). Contact gary.llil@dynatrace.com if problem persists"
        );
      });
  }

  getColumns() {
    const col0 = new Column("Select", false, " col5");
    const col1 = new Column("Info", false, " col40");
    const col2 = new Column("Tags", false, " col55");
    let columns = [col0, col1, col2];
    this.setState({ columns: columns });
  }

  showColumns() {
    const { columns } = this.state;
    return columns.map((c) => {
      const classNameValue =
        ["Action", "Time"].find((l) => l === c.name) !== undefined
          ? ""
          : "table-col";
      return (
        <th className={classNameValue + c.width} key={c.name}>
          {c.name}
        </th>
      );
    });
  }

  getStatusValue(
    isApproved: Boolean,
    isDeleted: Boolean,
    isProcess: Array<Boolean>,
    wasUpdated: Boolean
  ): String {
    if (
      isApproved == false &&
      isDeleted == false &&
      isProcess.some((value) => value === false)
    ) {
      return "TO_APPROVE";
    }

    if (wasUpdated == true) return "FILES_UPDATED";

    if (isApproved == true) return "APPROVED";

    if (
      isProcess.some((value) => value === true) &&
      isApproved == false &&
      isDeleted == false
    ) {
      return "REJECTED";
    }

    if (isDeleted == true) return "DELETED";

    return "TO_APPROVE";
  }
}

export default withRouter(HighspotFIles);
